module.exports = __webpack_public_path__ + "img/20190610161856509.95bba77f.png";